import { render, staticRenderFns } from "./addofflineDiscountCardSub.vue?vue&type=template&id=977ed35a&scoped=true&"
import script from "./addofflineDiscountCardSub.vue?vue&type=script&lang=js&"
export * from "./addofflineDiscountCardSub.vue?vue&type=script&lang=js&"
import style0 from "./addofflineDiscountCardSub.vue?vue&type=style&index=0&id=977ed35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977ed35a",
  null
  
)

export default component.exports